import React, { useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Container, heading, CaptionWrapper, caption } from './styles';
import { Button, Colors, IconSvg, Typography } from '@utex/ui-kit';

interface Props {
  title: string;
  value: React.ReactNode;
  valueForCopy?: string;
}

export const Item: React.FC<Props> = ({ title, value, valueForCopy }) => {
  const [isCopied, setIsCopied] = useState(false);

  let timeoutCopySuccess: NodeJS.Timeout;

  useEffect(() => {
    setIsCopied(false);
    return () => {
      clearTimeout(timeoutCopySuccess);
    };
  }, [value]);

  const onCopyHandler = () => {
    setIsCopied(true);
    timeoutCopySuccess = setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };

  return (
    <Container>
      <Typography.Text size="S" view="hint" css={heading}>
        {title}
      </Typography.Text>
      <CaptionWrapper>
        <Typography.Text size="S" css={caption}>
          {value}
        </Typography.Text>
        <CopyToClipboard text={valueForCopy || value?.toString() || ''} onCopy={onCopyHandler}>
          <Button view="transparent" size="XS" shape="square" isSuccess={isCopied}>
            <IconSvg src="copy" color={Colors.text.primary} />
          </Button>
        </CopyToClipboard>
      </CaptionWrapper>
    </Container>
  );
};
